<template>
   <div class="text-center" v-if="loading">
    <span>Loading</span><br>
  <CSpinner grow=true color="danger"></CSpinner>
  </div>
  <CCard v-else>
    <CCardHeader>
      <strong>Import Question</strong>
    </CCardHeader>
    <CCardBody>
      <CRow>
        <CCol sm="12">
          <CButton size="sm" variant="outline" color="success" class="mb-3"
            ><a
              :href="root_url + '/quizgiri_demo_questions.xlsx'"
              class="text-success"
              >Click here to Download Sample Data (.xlsx)</a
            ></CButton
          >
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="12">
          <div class="form-group">
            <label>Category</label>
            <select
              class="form-control"
              v-model="selected_category"
              @change="getTopics"
            >
              <option
                v-for="cat in categories"
                :value="cat.id"
                :key="cat.id"
                :class="{ 'font-weight-bold': cat.parent == '' }"
              >
                {{ cat.name }}
              </option>
            </select>
          </div>
        </CCol>
        <CCol sm="6">
          <label>Topic</label>
          <multiselect
            v-model="selected_topic"
            :options="topics"
            placeholder="Select one"
            label="name"
            track-by="id"
          >
          </multiselect>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="12">
          <CInputFile
            label=".xls file"
            vertical
            ref="file"
            type="file"
            id="file"
            @change="onImageChange"
          />
          <!-- <progress
            max="100"
            :value.prop="upload_percentage"
            v-if="upload_percentage > 0"
          ></progress> -->
        </CCol>
      </CRow>
    </CCardBody>
    <CCardFooter>
      <CButton @click="onSubmit" color="primary">
        <CIcon name="cil-check-circle" />Import Questions
      </CButton>
    </CCardFooter>
  </CCard>
</template>

<script>
const ADMIN_URL = process.env.VUE_APP_ADMIN_URL;
const ROOT_URL = process.env.VUE_APP_ROOT_URL;
export default {
  name: "QuestionImport",
  data() {
    return {
      loading : false,
      root_url: ROOT_URL,
      categories: [{ value: 0, label: "Select Category" }],
      import_file: "",
      topics: [],
      selected_category: "",
      selected_topic: "",
      upload_percentage: 0,
    };
  },
  created() {
    this.getCategories();
  },
  methods: {
    getCategories() {
      this.$axios
        .get(`${ADMIN_URL}/categories`)
        .then((response) => {
          this.categories = response.data.category_list;
        })
        .catch((e) => {
          console.log("error occurs", e);
        });
    },
    getTopics() {
      this.topics = [];
      this.selected_topic = "";
      this.$axios
        .get(`${ADMIN_URL}/topics/`, {
          params: {
            category_id: this.selected_category,
          },
        })
        .then((response) => {
          console.log(response.data);
          response.data.topic_list.forEach((e) => {
            this.topics.push({
              id: e.id,
              name: e.name,
            });
          });
        })
        .catch((e) => {
          console.log("error occurs", e);
        });
    },
    onImageChange(e) {
      console.log("event", e[0]);
      this.import_file = e[0];
    },
    async onSubmit(e) {
      e.preventDefault();
      this.loading = true
      const config = {};
      console.log('ssd',this.loading)
      let formData = new FormData();
      formData.append("topic_id", this.selected_topic.id);
      formData.append("file", this.import_file);

     await this.$axios
        .post(`${ADMIN_URL}/questions/import`, formData, {
          headers: {
            "content-type": "multipart/form-data",
            "Accept": "application/json",
          }
        })
        .then((response) => {
          console.log("Success", response);
          console.log(response.data);
          if (response.data.success) {
            this.$swal("Success", response.data.message, "success");
             
            window.location.href = "/questions";

          }
          else
          {
             this.$swal("Error", response.data.message, "error");
          }
          this.loading = false
        })
        .catch((error) => {
          console.log("Error  ... ", error);
           this.loading = false
          this.$swal("Error", error.response.message, "error");
        });
        
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
</style>
